/* (ignored) */


//////////////////
// WEBPACK FOOTER
// fs (ignored)
// module id = 2
// module chunks = 1